import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Consulting(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="Oracle Services">
                            <h2>TekRevol’s Oracle Professional Servicess</h2>
                        </div>
                        {/*<div*/}
                        {/*    className="main_para"><p>TekRevol's SAP consulting can help you customize SAP*/}
                        {/*    functionalities and match them with your business requirements and future scalability goals.*/}
                        {/*    You can add or accelerate features, combine functionalities, and put features into action*/}
                        {/*    according to your organizational structure and goals with compatible coding solutions.</p>*/}
                        {/*</div>*/}
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Oracle Consulting Services</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Oracle Solutions Implementation</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Oracle Database Management</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>TekRevol's Oracle Consulting Services support businesses influence the power of Oracle technologies to determine digital transformation and modernization. Our expertise in Oracle cloud solutions allows businesses to attain their IT objectives and encounter their exclusive business requirements with customized cloud solutions.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Our Oracle Solutions Implementation services assist businesses implement Oracle cloud solutions effortlessly, making sure that they are scalable, safe, and cost-effective. With TekRevol's knowledge in Oracle cloud technologies, businesses can control advanced tools and technologies to build state-of-the-art solutions that drive business development.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>TekRevol's Oracle Database Management services help businesses manage their Oracle databases competently and effectually. Our expertise in Oracle database technologies empowers us to safeguard that businesses can reach their data without any issue and steadily, while also improving performance and dropping costs.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Oracle Consulting Services</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's Oracle Consulting Services support businesses influence the power of Oracle technologies to determine digital transformation and modernization. Our expertise in Oracle cloud solutions allows businesses to attain their IT objectives and encounter their exclusive business requirements with customized cloud solutions.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Oracle Solutions Implementation</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our Oracle Solutions Implementation services assist businesses implement Oracle cloud solutions effortlessly, making sure that they are scalable, safe, and cost-effective. With TekRevol's knowledge in Oracle cloud technologies, businesses can control advanced tools and technologies to build state-of-the-art solutions that drive business development.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Oracle Database Management</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's Oracle Database Management services help businesses manage their Oracle databases competently and effectually. Our expertise in Oracle database technologies empowers us to safeguard that businesses can reach their data without any issue and steadily, while also improving performance and dropping costs.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Consulting;